import React from 'react'
import img1 from '../../assets/licencia.jpg'

const TopHomeInfo = () => {
  return (
    <div className='px-4 py-12 sm:w-screen sm:p-12 mb-4'>
      <div className='flex flex-row'>
        <div className='w-1/2 flex flex-col items-center justify-center sm:gap-14'>
         <h1 className='text-xl sm:text-6xl font-bold font-roboto'>Dra. M Weed</h1>
          <div className='w-full '>
            <p className='text-[12px] ml-4 sm:text-[20px] font-roboto text-justify -tracking-normal'>Bienvenidx a nuestra página web! Mi nombre es Martina Fernandez Vargas (MN.178139) estoy graduada en la UBA y cuento con un posgrado de la UGR en endocannabinología.

Asi como vos tambien cultivo y hago uso del cannabis hace muchos años!
Como profesional de la salud realizo consultas médicas vinculantes al REPROCANN y consultas de endocannabinología, con información para un buen uso y terapéutica adecuada según cada patología.

Con nuestra página web y acompañamiento vía whatsapp te ayudaré a generar tu licencia del REPROCANN! 
Gracias por elegirnos!
</p>  

          </div>
        </div>

        <div className='w-1/3 ml-6 sm:w-1/2 flex items-center justify-center'>
            <img src={img1} alt="Img not found" />
        </div>
      </div>      
    </div>
  )
}

export default TopHomeInfo